<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <Login :tab="tab" @chooseTab="chooseTab" />
  </div>
</template>

<script>
import Login from "@/views/Login";
import { sessionStore } from '@/utils/data-management'
export default {
  name: 'app',
  components: {
    Login
  },
  data() {
    return {
      tab: 1,
    }
  },
  watch: {
    show(newVal, oldVal) {
      this.tab = sessionStore.get('toLoginTypeRPRT') * 1
    },
  },
  computed: {
    show() {
      return this.$store.state.token
    },
  },
  mounted() { },
  created() {
    window.scrollTo(0, 0)
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStore.get('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, sessionStore.get('store')))
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStore.set('store', this.$store.state)
    })
  },
  methods: {
    chooseTab(v) {
      this.tab = v * 1
    },
  }
}
</script>

<style lang="scss">
body {
  margin: 0px;
  padding: 0px;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  text-rendering: optimizeLegibility;
  background: rgba(248, 249, 251, 1);
  overflow-y: scroll !important;
}
#app {
  font-family: PingFangSC-Regular, PingFang SC, Avenir, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height:100%;
  height: auto !important;
  height: 100%; /*IE6不识别min-height*/
  position: relative;
}

</style>
